module.exports = __webpack_public_path__ + "img/homepage-content-image-hyundai.35f772cf.jpg";